import { useLocation, useNavigate, useParams } from "react-router-dom";
import { PhysicianReviewItemView } from "@/features/physician/review-queue/components/PhysicianReviewItemView";

export function PhysicianReviewItemPage() {
  const { itemId = "" } = useParams<{ itemId: string }>();
  const navigate = useNavigate();
  // Opened from My Items (/physician/my-items/:id) → back to My Items; otherwise the Review Queue.
  const fromMyItems = useLocation().pathname.startsWith("/physician/my-items/");
  const backTo = fromMyItems ? "/physician/my-items" : "/physician";
  const back = () => navigate(backTo);
  // Keyed per item so nothing from one item's screen survives into the next.
  return (
    <PhysicianReviewItemView
      key={itemId}
      itemId={itemId}
      backLabel={fromMyItems ? "My Items" : "Review Queue"}
      onBack={back}
      onReleased={back}
      onDecided={back}
    />
  );
}
